import axios from "axios";

const url = process.env.REACT_APP_API_URL_FILE

export default class UploadService {
    uploadFile(nomorAju, file) {
        const formData = new FormData()
        formData.append("file", file)
        return axios.post(url + '/upload?nomorAju=' + nomorAju, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}